import { useRouter } from "next/router";
import { useEffect } from "react";

const useScrollRestoration = () => {
  const router = useRouter();

  useEffect(() => {
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";

      const onRouteChangeStart = () => {
        sessionStorage.setItem("scrollPosition", window.scrollY.toString());
      };

      const onRouteChangeComplete = () => {
        const savedScrollPosition = sessionStorage.getItem("scrollPosition");
        if (savedScrollPosition !== null) {
          window.scrollTo({
            top: parseInt(savedScrollPosition, 10),
            behavior: "instant",
          });
          sessionStorage.removeItem("scrollPosition");
        }
      };

      router.events.on("routeChangeStart", onRouteChangeStart);
      router.events.on("routeChangeComplete", onRouteChangeComplete);

      return () => {
        router.events.off("routeChangeStart", onRouteChangeStart);
        router.events.off("routeChangeComplete", onRouteChangeComplete);
      };
    }
  }, [router]);
};

export default useScrollRestoration;
